/* eslint-disable ember/no-computed-properties-in-native-classes */
// Extends From
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { get, set, action, computed } from '@ember/object';
import { mapBy } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';
// Internal Imports
import { filterValue } from '@linc-technologies/linced-common/utils/filtering';
import DataType from '@linc-technologies/linced-common/enums/data-type';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';

export default class MedicalScheduleController extends Controller {
  @action
  setStatus(value) {
    this.status = value;
  }

  @tracked
  filters = [];
  @tracked status = false;

  // scheduleMedications is an intermediary CP so the @each dependent key below
  // stays one level deep.
  @mapBy('model.schedules', 'medication')
  scheduleMedications;

  @computed(
    'model.schedules.@each.deleted',
    'scheduleMedications.@each.deleted',
  )
  get currentSchedules() {
    return this.model.schedules.filter(
      (item) => !item.deleted && !item.get('medication.deleted'),
    );
  }

  @computed('model.group.currentLearnerMemberIds.[]', 'currentSchedules.[]')
  get groupSchedules() {
    return this.currentSchedules.filter((schedule) => {
      return this.model.group.currentLearnerMemberIds.includes(
        schedule.medication.get('person_id'),
      );
    });
  }

  @computed('groupSchedules.@each.scheduledToday')
  get todaysSchedules() {
    return this.groupSchedules.filter((schedule) => {
      return schedule.scheduledToday;
    });
  }

  @computed(
    'todaysSchedules.{[],@each.administeredToday}',
    'filters.@each.{field,value}',
    'status',
  )
  get filteredSchedules() {
    // Filter by status
    let todaysSchedules = this.todaysSchedules.filter((row) => {
      return row.administeredToday === this.status;
    });

    // Determine datatypes for any specified filters.
    let filters = this.filters.map((filter) => {
      return {
        key: filter.field,
        dataType: DataType.STRING,
        value: filter.value,
      };
    });

    // Apply all filters to each row in one hit, to avoid iterating over a
    // (potentially) large dataset multiple times.
    return todaysSchedules.filter((row) => {
      return filters.every((filter) => {
        // Generic filter processing.
        return filterValue(
          get(row, filter.key) ?? '',
          filter.dataType,
          filter.value,
        );
      });
    });
  }

  @action
  filter(field, value) {
    let filter = findBy(this.filters, 'field', field);
    if (isEmpty(filter)) {
      // No existing filter on this field; add it.
      this.filters = [...this.filters, { field, value }];
      return;
    }

    if (isEmpty(value)) {
      // Filter has been cleared; remove it.
      this.filters = this.filters.filter((f) => f !== filter);
    } else {
      // Existing filter has been changed; update it.
      set(filter, 'value', value);
    }
  }
}
